import _ from 'lodash';
import { createSelector } from 'reselect';
import { getScheduleHighlights } from '../../../../../shared/frontend/scripts/recruitment/utils';
import { serializeRecruitmentProfile } from '../../../../../shared/frontend/scripts/recruitment/utils';
import { getRequirementHighlights } from '../shared/recruitment/utils';

/*
 * team details:
 */
const teamDetailsState = (st: any) => st?.team;

export const teamIdSelector = createSelector(
  teamDetailsState,
  ({ viewTeamRoster }) => viewTeamRoster?.response?.team?.group_id
);

/*
 * team recruitment page
 */

const teamRecruitmentPageStateSelector = (st: any) => st.team.teamRecruitment;
export const applicationErrorMsgSelector = createSelector(
  teamRecruitmentPageStateSelector,
  ({ errorMessage }) => errorMessage
);

export const applicationModalVisibilitySelector = createSelector(
  teamRecruitmentPageStateSelector,
  ({ applicationModalOpen }) => applicationModalOpen
);

const _applicationStateSelector = createSelector(teamRecruitmentPageStateSelector, ({ application }) => application);
export const applicationStatusSelector = createSelector(_applicationStateSelector, ({ loading, loaded, error }) => ({
  loading,
  loaded,
  error
}));
export const threadIdSelector = createSelector(
  teamRecruitmentPageStateSelector,
  ({ application }) => application.threadId
);

export const teamRecruitmentProfilePageStatusSelector = createSelector(
  teamRecruitmentPageStateSelector,
  ({ loading, loaded, error }) => ({
    loading,
    loaded,
    error
  })
);

const getProgressHighlights = (team: any) => {
  const highlights = [];

  const callouts = team?.teamMythicPlusCallouts?.response || {};

  if (callouts.season) {
    highlights.push({
      label: callouts.season?.name,
      value: callouts?.score
    });
  }

  if (callouts.callouts) {
    for (const keyInfo of callouts.callouts) {
      highlights.push({
        label: `Timed ${keyInfo.level} + Runs`,
        value: keyInfo.count
      });
    }
  }

  return highlights;
};

export const teamRecruitmentProfilesSelector = createSelector(
  teamRecruitmentPageStateSelector,
  teamDetailsState,
  ({ profiles }, team) =>
    _.map(profiles || [], (p) => {
      const profile = serializeRecruitmentProfile({}, p);

      return {
        profile,
        progressHighlights: getProgressHighlights(team),
        requirementHighlights: getRequirementHighlights(profile),
        scheduleHighlights: getScheduleHighlights(profile)
      };
    })
);

// the profile for which the user wants to apply with
export const sourceProfileIdSelector = createSelector(
  teamRecruitmentPageStateSelector,
  ({ sourceProfileId }) => sourceProfileId
);
export const targetProfileIdSelector = createSelector(
  teamRecruitmentPageStateSelector,
  ({ targetProfileId }) => targetProfileId
);
export const applicationMessageSelector = createSelector(teamRecruitmentPageStateSelector, ({ message }) => message);

export const applicationIdsSelector = createSelector(
  sourceProfileIdSelector,
  targetProfileIdSelector,
  applicationMessageSelector,
  (sourceProfileId, targetProfileId, message) => {
    return message ? { targetProfileId, sourceProfileId, message } : { targetProfileId, sourceProfileId };
  }
);

export const targetProfileSelector = createSelector(
  targetProfileIdSelector,
  teamRecruitmentProfilesSelector,
  (targetProfileId, profiles) => {
    return targetProfileId > 0 ? _.find(profiles, (p) => p.profile.id === targetProfileId) : undefined;
  }
);
